import React from 'react';
import { IconProps } from './type';

export const PhoneIcon = ({ color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50732 4.42704C7.67681 4.44203 7.83096 4.53131 7.9283 4.67088L10.5153 8.38013C10.6747 8.60868 10.6473 8.91862 10.4503 9.11565L8.27303 11.2929C8.83148 12.1467 9.4961 12.9596 10.2681 13.7315C11.0401 14.5035 11.8529 15.1681 12.7067 15.7266L14.884 13.5494C15.081 13.3523 15.391 13.3249 15.6195 13.4843L19.3288 16.0713C19.4683 16.1687 19.5576 16.3228 19.5726 16.4923C19.5876 16.6618 19.5267 16.8292 19.4064 16.9495L18.5743 17.7816C17.8707 18.4852 16.8378 18.7463 15.8844 18.4614C13.4899 17.7461 11.3459 16.4357 9.45491 14.5447C7.56395 12.6538 6.25352 10.5098 5.53819 8.11525C5.25334 7.16179 5.51438 6.12893 6.21802 5.42529L7.05009 4.59322C7.17041 4.4729 7.33783 4.41206 7.50732 4.42704ZM13.7268 16.3329C14.5225 16.7601 15.3514 17.102 16.2136 17.3596C16.7621 17.5234 17.3563 17.3733 17.7612 16.9684L18.1078 16.6218L15.3566 14.7031L13.7268 16.3329ZM7.66676 10.2728L9.29657 8.643L7.3778 5.89186L7.03119 6.23846C6.62637 6.64329 6.47619 7.23752 6.64007 7.78607L6.64007 7.78608C6.89763 8.64825 7.23957 9.47712 7.66676 10.2728Z"
        fill={color}
      />
    </svg>
  );
};
